import React, { createContext, useCallback, useContext, useMemo } from 'react';
import { Object3D } from 'three';
import FocusPoints from '../../../data/FocusPoints';
import { useDetailViewContext } from '../../../context/DetailViewContext';

// this only exists to link 3D objects to the active focus ID

export type FocusPoint = {
    target: Object3D,
    size: number
};

type FocusData = {
    setFocusPoint: (id: FocusPoints, target: Object3D, size: number) => void;
    focusPoint: FocusPoint;
}

export const FocusContext = createContext<FocusData>({
  setFocusPoint: () =>
  { /* */
  },
  focusPoint: { target: new Object3D(), size: 0 }
});

export default function FocusContextProvider({ children }: JSX.ElementChildrenAttribute): JSX.Element
{
  const focusObjects = useMemo<FocusPoint[]>(() => [], []);

  const { activeFocusID } = useDetailViewContext();

  const setFocusPoint = useCallback((id: FocusPoints, target: Object3D, size: number) =>
  {
    focusObjects[id] = { target, size };
  }, [ focusObjects ]);

  const focusPoint = useMemo(() => focusObjects[activeFocusID], [ activeFocusID, focusObjects ]);

  return (
    <FocusContext.Provider
      value={{
        setFocusPoint,
        focusPoint
      }}
    >
      {children}
    </FocusContext.Provider>
  );
}

export const useFocusContext: () => FocusData = () => useContext(FocusContext);